<template>
  <div class="ccs-layout">
    <div class="ccs-layout ccs-6 ccs-layout--no-pad">
      <ccs-input class="ccs-12" v-model.trim="fieldsValues.user_id" v-bind="fieldsDefinitions.user_id"
        :items="usersForSelect" @change="onUserSearch"
        @error="(err) => setFieldError('user_id', err)"/>
      <ccs-input class="ccs-12" v-model.trim="fieldsValues.role_id" v-bind="fieldsDefinitions.role_id"
        :items="rolesForSelect" @change="onRoleSearch"
        @error="(err) => setFieldError('role_id', err)"/>
    </div>
    <div class="ccs-layout ccs-6 ccs-layout--no-pad">
      <ccs-input class="ccs-9" v-model.trim="fieldsValues.label" v-bind="fieldsDefinitions.label"
        @error="(err) => setFieldError('user_id', err)"/>
      <div class="ccs-3 button--add">
        <button class="ccs-button ccs-button--small ccs-12" @click="addLabel">
          Добавить
        </button>
      </div>
      <div class="ccs-layout ccs-12 ccs-layout--scroll user-tags_list">
        <div class="ccs-tag ccs-tag--normal" v-for="(item, index) in labels" :key="index" @click="removeLabel(item)">
          {{ `${item}` }}
        </div>
      </div>
    </div>
    <div class="ccs-layout ccs-layout--no-pad">
      <div>
        <button class="ccs-button" @click="submit">
          Добавить
        </button>
      </div>
      <div>
        <button class="ccs-button ccs-button--light" @click="$emit('close')">
          Отмена
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import FormHelper from '@/mixins/FormHelper.js';
import AutocompleteParent from '@/mixins/AutocompleteParent.js';

import Input from '@/components/forms/Input.vue';

export default {
  name: 'AddUserToEvent',
  mixins: [AutocompleteParent, FormHelper],
  components: {
    'ccs-input': Input,
  },
  data() {
    return {
      fieldsDefinitions: {
        user_id: {
          isValid: false,
          error: '',
          required: true,
          type: "autocomplete",
          label: "Пользователь",
          placeholder: "Введите 3 символа для поиска",
        },
        role_id: {
          isValid: false,
          error: '',
          required: true,
          type: "autocomplete",
          label: "Роль",
          placeholder: "Введите 3 символа для поиска",
        },
        label: {
          isValid: true,
          error: '',
          required: false,
          type: "text",
          label: "Теги (Регион/ВУЗ/Компания)",
          placeholder: "Введите тег",
        },
      },
      fieldsValues: {
        user_id: undefined,
        role_id: undefined,
        label: '',
      },
      usersForSelect: [],
      rolesForSelect: [],
      labels: [],
    }
  },
  computed: {
    ...mapState('events', ['event']),
  },
  methods: {
    ...mapActions('events', ['addUserToEvent']),
    async onUserSearch(text) {
      [this.usersForSelect] = await this.getAutocompleteData('/v1/users/list', text, 'id', 'email');
    },
    async onRoleSearch(text) {
      [this.rolesForSelect] = await this.getAutocompleteData('/v1/roles/list', text);
    },
    async submit() {
      this.validateForm();
      if (this.isFormValid) {
        try {
          if (this.labels.length !== 0) {
            await this.addUserToEvent({
              userID: this.fieldsValues.user_id,
              request: {
                role_id: this.fieldsValues.role_id,
                labels: this.labels,
              },
            });
          } else {
            await this.addUserToEvent({
              userID: this.fieldsValues.user_id,
              request: {
                role_id: this.fieldsValues.role_id,
              },
            });
          }
          this.$toasted.success('Участник привязан');
          this.$emit('close');
        } catch (err) {
          this.showServerValidationErrors(err);
        }
      }
    },
    addLabel() {
      if (this.fieldsValues.label) {
        this.labels.push(this.fieldsValues.label);
        this.fieldsValues.label = '';
      }
    },
    removeLabel(label) {
      this.labels = this.labels.filter(item => {
        return item !== label;
      });
    }
  },
}
</script>

<style lang="scss" scoped>
.button--add {
  margin-top: 22px;
}

.user-tags_list {
  max-height: 100px;
}
</style>